<template>
  <div class="grid grid-cols-2 gap-6">
    <div
      v-if="hasProsCons('pros')"
      class="space-y-2 p-4 bg-green-50 rounded-lg"
    >
      <h4 class="font-semibold text-green-700 flex items-center gap-2">
        <Icon
          name="i-heroicons-check-circle"
          class="w-5 h-5"
        />
        Pros
      </h4>
      <div class="scrollable-content">
        <ul
          v-if="Array.isArray(pros)"
          class="text-sm text-gray-700 list-disc pl-4 space-y-1"
        >
          <li
            v-for="(pro, index) in pros"
            :key="index"
          >
            {{ pro }}
          </li>
        </ul>
        <p
          v-else
          class="text-sm text-gray-700"
          :class="{
            'whitespace-pre-line': true,
            'break-words': true
          }"
        >
          {{ pros }}
        </p>
      </div>
    </div>
    <div
      v-if="hasProsCons('cons')"
      class="space-y-2 p-4 bg-red-50 rounded-lg"
    >
      <h4 class="font-semibold text-red-700 flex items-center gap-2">
        <Icon
          name="i-heroicons-exclamation-circle"
          class="w-5 h-5"
        />
        Cons
      </h4>
      <div class="scrollable-content">
        <ul
          v-if="Array.isArray(cons)"
          class="text-sm text-gray-700 list-disc pl-4 space-y-1"
        >
          <li
            v-for="(con, index) in cons"
            :key="index"
          >
            {{ con }}
          </li>
        </ul>
        <p
          v-else
          class="text-sm text-gray-700"
          :class="{
            'whitespace-pre-line': true,
            'break-words': true
          }"
        >
          {{ cons }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  pros?: string[] | string
  cons?: string[] | string
  lineClamp?: boolean
}>()
const hasProsCons = (type: 'pros' | 'cons') => {
  const value = props[type]
  if (!value) return false
  if (Array.isArray(value)) return value.length > 0
  return value.trim().length > 0
}
</script>

<style scoped>
.break-words {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.scrollable-content {
  max-height: 120px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.5);
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(156, 163, 175, 0.8);
}

/* Ensure proper scrolling behavior when line-clamp is disabled */
.scrollable-content .line-clamp-3 {
  -webkit-line-clamp: unset;
  display: block;
}
</style>
